"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissibleUpgradeBanner = void 0;
var react_1 = __importDefault(require("react"));
var PromptBanner_1 = require("Common/Prompt/PromptBanner");
var inversify_react_1 = require("inversify-react");
var UpgradeContainer_1 = require("./UpgradeContainer");
var UpgradeTelemetry_1 = require("./UpgradeTelemetry");
var UpgradeButton_1 = require("./UpgradeButton");
var AdminOnly_1 = require("Utils/AdminOnly");
var UpgradeConstants_1 = require("./UpgradeConstants");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DismissibleUpgradeBanner = function (_a) {
    var _b;
    var className = _a.className, promptId = _a.promptId, telemetryOrigin = _a.telemetryOrigin;
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    if (usingFeature(FeatureFlag_1.default.AdvancedAnalyticsLimits))
        return null;
    return (react_1.default.createElement(UpgradeContainer_1.UpgradeContainer, null,
        react_1.default.createElement(PromptBanner_1.PromptBanner, { className: className, promptId: promptId },
            react_1.default.createElement(UpgradeTelemetry_1.UpgradeDiscoveryViewedTelemetry, { telemetryOrigin: telemetryOrigin },
                react_1.default.createElement(PromptBanner_1.PromptBannerUpgradeContent, { heading: UpgradeConstants_1.UPGRADE_HEADING, subtitle: ((_b = rootDataStore.userDataStore) === null || _b === void 0 ? void 0 : _b.isAdmin)
                        ? UpgradeConstants_1.PIPELINE_REPORT_UPGRADE_SUBTITLE_ADMIN
                        : UpgradeConstants_1.PIPELINE_REPORT_UPGRADE_SUBTITLE_CREATOR, button: react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                        react_1.default.createElement(UpgradeButton_1.UpgradeButton, { telemetryOrigin: telemetryOrigin })) })))));
};
exports.DismissibleUpgradeBanner = DismissibleUpgradeBanner;
